import type {Participant} from "@/raids/rest/RaidSchema.ts";
import {useState} from "react";
import {useMarkResourceReceived} from "@/raids/rest/RaidQueries.ts";
import {Button, message, Tag} from "antd";

type Props = {
  id: Participant['id'],
  retrieved: boolean | null | undefined,
}

function ParticipantResourceRetriever({id, retrieved}: Props) {
  const [msgApi, contextHolder] = message.useMessage();

  const [resourcesRetrieved, setResourcesRetrieved] = useState(retrieved);

  const {mutate: markReceived, isPending} = useMarkResourceReceived({
    onSuccess: () => {
      setResourcesRetrieved(true);
      void msgApi.success("Markiert");
    }
  });

  return (
      <>
        {contextHolder}
        {resourcesRetrieved && <Tag color="success">Ressourcen erhalten</Tag>}
        {!resourcesRetrieved && <Button
            loading={isPending}
            disabled={isPending}
            onClick={() => markReceived(id)}
        >
          Ressourcen ausgeben
        </Button>}
      </>
  )
}

export {ParticipantResourceRetriever};